<!--app.vue-->
<template>
    <v-app class="global-font">
        <router-view v-slot="{ Component }">
            <!-- <transition :name="transitionName"> -->
            <!-- <component :is="Component" /> -->
            <!-- </transition> -->
            <keep-alive :include="mainPages" >
                <component :is="Component" />
            </keep-alive>
        </router-view>

        <DialogWarning :dialog="showDialog" @update:dialog="setShowDialog" />

        <v-snackbar v-model="showSnackbar" :timeout="10000" class="mb-16">
            {{ snackbarMessage }}
        </v-snackbar>

        <!-- <DisplayInstallApp /> -->

    </v-app>
</template>

<script>
import { onMounted, onBeforeUnmount } from 'vue';
import { Capacitor } from '@capacitor/core';
import { StatusBar } from '@capacitor/status-bar';
import { ScreenOrientation } from '@capacitor/screen-orientation';
import { mapState, mapMutations, mapActions } from 'vuex';
import DialogWarning from './components/connected-components/Dialog-Warning.vue';
// import { useRoute } from 'vue-router';
// import { computed } from 'vue'; // Import de 'computed'
import { PrivacyScreen } from '@capacitor-community/privacy-screen';

// import DisplayInstallApp from '@/components/connected-components/Display-Install-App.vue';


export default {
    components: {
        DialogWarning,
    // DisplayInstallApp,

    },
    data() {
        return {
            isOnline: navigator.onLine, // Vérifie si l'utilisateur est initialement en ligne
            showSnackbar: false,
            snackbarMessage: '',
        };
    },
    computed: {
       
        ...mapState(['showDialog']),

         // 🔥 Pages principales avec bottom navigation à garder en cache
        mainPages() {
            return [
                'homePage',           // Page d'accueil
                'LibraryPage',        // Page de recherche
                'NotificationsPage',  // Page notifications
                'ProfilPage',
                'ProfilPageOffline',          // Page profil
                // 'PublishPage',
                'unConnected',
                'LibraryPageOffline',
                'NotificationsPageOffline',
                // 'PublishPageOffline',
                // 'book-details',
            ]
        },
        // 🔥 Composants à exclure explicitement du cache
        // excludedComponents() {
        //     return [
        //         'NotificationBadge',
        //         'MessageBadge',
        //         'NotificationMessage',
        //         'NotificationMessageTop'
        //     ]
        // }
    },
    methods: {
        ...mapActions(['loadUserPhoto']), // Action pour charger la photo utilisateur
        ...mapMutations(['setShowDialog']),
        handleOnline() {
            this.isOnline = true;
            this.snackbarMessage = 'Ou anliy!';
            this.showSnackbar = true;
        },
        handleOffline() {
            this.isOnline = false;
            this.snackbarMessage =
                'Koneksyon entènèt ou tonbe. Ou ap fonksyone san entènet. Sa rann aplikasyon an lan.';
            this.showSnackbar = true;
        },
        async configureStatusBar() {
            if (Capacitor.isNativePlatform()) {
                // Configuration de la status bar uniquement sur les plateformes natives
                await StatusBar.setOverlaysWebView({ overlay: false });
                await StatusBar.setBackgroundColor({ color: '#FFFFFF' });
                await StatusBar.setStyle({ style: 'LIGHT' });
                await StatusBar.show();
                await ScreenOrientation.lock({ orientation: 'portrait' });
            }
        },

        async configurateScreeProtection() {
            if (Capacitor.isNativePlatform()) {
                     // Activer la protection d'écran
    // PrivacyScreen.enable()
            PrivacyScreen.disable()
      .then(() => console.log("Privacy screen enabled"))
      .catch((err) => 
      console.error("Error enabling privacy screen", err)
       );
            }
        }
    },
    setup() {
        onMounted(async () => {
            if (Capacitor.isNativePlatform()) {
                // Configuration IMMÉDIATE de la StatusBar
                try {
                    await StatusBar.setOverlaysWebView({ overlay: false });
                    await StatusBar.setBackgroundColor({ color: '#FFFFFF' });
                    await StatusBar.setStyle({ style: 'LIGHT' });
                    await StatusBar.show();
                    await ScreenOrientation.lock({ orientation: 'portrait' });
                } catch (error) {
                    // console.error('Erreur StatusBar:', error);
                }
            }
            
        });

        onBeforeUnmount(async () => {
            if (Capacitor.isNativePlatform()) {
                await StatusBar.setBackgroundColor({ color: '#FFFFFF' });
                await StatusBar.setStyle({ style: 'LIGHT' });
            }
        });
    },
    async mounted() {
        await this.loadUserPhoto(); // Charger la photo utilisateur dès que l'application est montée
        // Écoute les événements réseau
        window.addEventListener('online', this.handleOnline);
        window.addEventListener('offline', this.handleOffline);

        // StatusBar configuration immédiate (sans setTimeout)
        if (Capacitor.isNativePlatform()) {
            await StatusBar.setOverlaysWebView({ overlay: false });
            await StatusBar.setBackgroundColor({ color: '#FFFFFF' });
            await StatusBar.setStyle({ style: 'LIGHT' });
            await StatusBar.show();
        }

         await this.configurateScreeProtection();

    },
    beforeUnmount() {
        // Nettoie les écouteurs pour éviter les fuites mémoire
        window.removeEventListener('online', this.handleOnline);
        window.removeEventListener('offline', this.handleOffline);
    },
};
</script>

<style>
.global-font {
    font-family: "Plus Jakarta Sans", "Noto Sans", sans-serif;
}
.v-snackbar {
  color: black !important; /* optionnel, pour que le texte reste visible */
}

/* Transition gauche à droite */
.slide-left-enter-active, .slide-left-leave-active {
  transition: transform 0.3s ease-out, opacity 0.3s;
}
.slide-left-enter-from {
  transform: translateX(-100%);
  opacity: 0;
}
.slide-left-leave-to {
  transform: translateX(100%);
  opacity: 0;
}

/* Transition fade */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s ease-in-out;
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
}

</style>

